<template>
  <div class="is-relative" :style="`width: ${width}px; height: ${height}px;`">
    <template v-if="isLoading">
      <TrfGlobalLoader type="overlay" />
    </template>
    <template v-else>
      <img class="fotoUsuario" :class="{'is-rounded': isRounded}" :src="imagemCarregada" :alt="nome" :style="`width: ${width}px; height: ${height}px; object-fit: 'cover';`" />
      <div v-if="useTooltip" class="tooltip">
        <slot>
          {{nome}}
        </slot>
      </div>
    </template>
  </div>
</template>
<script>
import {fotoUsuarioUtils} from '../../util/fotoUsuario.utils'
import TrfGlobalLoader from '../GlobalLoader'
export default {
  name: "TrfFotoUsuario",
  components: {
    TrfGlobalLoader
  },
  props: {
    fotoID: {
      type: [String, Number, null],
      default: 0,
      required: true
    },
    nome: String,
    useTooltip: {
      type: Boolean,
      default: false,
      required: false
    },
    isRounded: {
      type:Boolean,
      default: true,
      required: false
    },
    width: {
      type:Number,
      default: 100,
      required: false
    },
    height: {
      type:Number,
      default: 100,
      required: false
    }
  },
  data() {
    return {
      isLoading: true,
      imagemCarregada: null
    }
  },
  methods: {
    async adquirirImagem(fotoID) {
      this.isLoading = true;
      const foto = await fotoUsuarioUtils.adquirirFotoPorID(fotoID);
      this.isLoading = false;
      this.imagemCarregada = foto;
      return this.imagemCarregada;
    }
  },
  watch: {
    fotoID(valorNovo, valorVelho) {
      if(valorNovo != valorVelho) {
        const foto = this.adquirirImagem(this.fotoID);
      }
    }
  },
  async mounted() {
    const foto = this.adquirirImagem(this.fotoID);
  }
};
</script>
<style lang="scss" scoped>
  @import "../../assets/sass/variables.scss";
  .tooltip {
    pointer-events: none;
    opacity: 0;
    min-width: 200%;
    max-width: 300%;
    padding: 0.75em;
    position: absolute;
    z-index: 1;
    top:100%;
    border-radius: 5px;
    left: 50%;
    transform:translateX(-50%);
    background-color: #fff;
    box-shadow: 0 2px 15px rgb(50 50 93 / 10%), 0 2px 15px rgb(0 0 0 / 7%);
    transition: opacity 0.35s ease 0s;
  }
  .is-rounded {
    border-radius:50%;
  }
  .fotoUsuario:hover + .tooltip, .fotoUsuario:focus + .tooltip,
  .fotoUsuario:active + .tooltip, .tooltip:hover, .tooltip:focus,
  .tooltip:focus-within {
    opacity: 0.75;
    pointer-events: auto;
  }
</style>